
































import {Component, Vue} from 'vue-property-decorator'
import Carga from '@/model/resource/Carga'
import DevolverNota from '@/model/request/DevolverNota'
import {$} from 'simpli-web-sdk'

const sha1 = require('sha1')

@Component
export default class ModalConfirmEditCarga extends Vue {
  password = ''
  carga = new Carga()

async openEvent(id: number) {
    await this.carga.getCarga(id)
    this.$emit('open')
  }

  async next() {
    const request = new DevolverNota()

    request.password = sha1(this.password)
    request.idCarga = this.carga.$id

    await this.carga.setCargaStatusToPendent(request)
    $.snotify.success(this.$t('modal.modalConfirmEditCarga.success'))
    this.$emit('changeCarga')
    this.close()
  }
  close() {
    this.$modal.close('modalConfirmEditCarga')
  }
  closeEvent() {
    this.$emit('close')
  }
}
